import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { ThemeProvider } from '@mui/material/styles';
import ProspectSearch from '@/components/ProspectSearch/ProspectSearch.tsx';
import theme from '@/theme.ts';

function FindResidentHeroSection() {
  return (
    <ThemeProvider theme={theme}>
      <Box
        bgcolor="rgb(220 220 220)"
        display="flex"
        alignItems="center"
        sx={{
          height: '250px',
          flexDirection: 'column',
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          sx={{
            flexDirection: 'column',
            mt: '40px',
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,
            }}
            variant="h3"
            color={theme.palette.primary.main}
          >
            Find Prospect
          </Typography>
          <Divider
            variant="middle"
            sx={{
              backgroundColor: theme.palette.primary.main,
              width: 'calc(100% + 10px)',
              borderBottomWidth: '5px',
            }}
          />
        </Box>
        <ProspectSearch />
      </Box>
    </ThemeProvider>
  );
}

export default FindResidentHeroSection;
